module.exports = __webpack_public_path__ + "static/media/book.6644cd11.png";